<script>
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsDialog from 'base/hs-dialog/hs-dialog'
import CDialogHeader from "@/components/c-header/c-dialog-header.vue";
import HsButton from 'base/hs-button/hs-button'
import {
  minRoomAmount,
  maxRoomAmount,
  minAdultAmount,
  minChildAmount,
  maxTotalAmount,
  getAgesText
} from "@/components/c-check-room/c-check-room";
import {nextTick} from "vue";
import CCheckRoomAges from "@/components/c-check-room/c-check-room-ages.vue";
import Teleport from "@/base/hs-teleport/hs-teleport.vue";

export default {
  name: "c-check-room",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: ''
    },
    positionHeight: {
      type: String,
      default: ''
    },
    RoomAmount: {
      type: Number,
      default: 1
    },
    AdultAmount: {
      type: Number,
      default: 2
    },
    ChildAmount: {
      type: Number,
      default: 0
    },
    maxRooms: { // 最大入住房间数
      type: Number,
      default: 0
    },
    maxPeopleAmount: { // 最大入住人数
      type: Number,
      default: 0
    },
    ages: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      minRoomAmount,
      maxRoomAmount,
      minAdultAmount,
      minChildAmount,
      maxTotalAmount,

      currentRoomAmount: 1,
      currentAdultAmount: 2,
      currentChildAmount: 0,
      currentAges: [],
      showCCheckRoomAges: false, // 年龄组件显隐
      cCheckRoomAge: 0,
      cCheckRoomAgeIndex: 0,
    }
  },
  computed: {
    currentShow: {
      get: function () {
        return this.show
      },
      set: function (val) {
        this.$emit('update:show', val)
      }
    },
    PeopleAmountLimit() {
      return this.maxPeopleAmount || maxTotalAmount
    },
    RoomAmountLimit() {
      return this.maxRooms || maxRoomAmount
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.currentRoomAmount = this.RoomAmount
        this.currentAdultAmount = this.AdultAmount
        this.currentChildAmount = this.ChildAmount
        this.initAgesWithOther(this.currentChildAmount, this.ages)
      }
    },
    currentChildAmount() {
      this.initAgesWithOther(this.currentChildAmount, this.currentAges)
    }
  },
  methods: {
    getAgesText,
    /** 根据儿童数量和原有年龄数组 更新 当前年龄数组 */
    initAgesWithOther(ChildAmount, ages) {
      if (ages.length >= ChildAmount) {
        this.currentAges = ages.slice(0, ChildAmount)
      } else {
        this.currentAges.length = ChildAmount; // 扩展数组长度
        this.currentAges = Array.from(ages, v => v || v === 0 ? v : 10) // 对数组空值填充固定值 10
      }

    },
    // 房间数改变
    roomAmountChange(value) {
      value = Number(value || 0)
      if (value <= this.RoomAmountLimit) {
        this.currentRoomAmount = value
      } else {
        let oldVal = this.currentRoomAmount
        this.currentRoomAmount = oldVal
      }
      this.$refs.vanStepper1 && this.$refs.vanStepper1.$forceUpdate()
    },
    changeFun(value) {
      value = Number(value || 0)
      if (value + this.currentChildAmount <= this.PeopleAmountLimit) {
        this.currentAdultAmount = value
      } else {
        let oldVal = this.currentAdultAmount
        this.currentAdultAmount = oldVal
      }
      this.$refs.vanStepper2 && this.$refs.vanStepper2.$forceUpdate()
    },
    changeChildFun(value) {
      value = Number(value || 0)
      if (value + this.currentAdultAmount <= this.PeopleAmountLimit) {
        this.currentChildAmount = value
      } else {
        let oldVal = this.currentChildAmount
        this.currentChildAmount = oldVal
      }
      this.$refs.vanStepper3 && this.$refs.vanStepper3.$forceUpdate()
    },
    /** 打开选择年龄弹框 */
    openCCheckRoomAge(age, index) {
      this.cCheckRoomAge = age
      this.cCheckRoomAgeIndex = index
      this.showCCheckRoomAges = true
    },

    /** 年龄选择器回调 */
    cCheckRoomAgesCallback(age, index) {
      this.currentAges[index] = age
    },

    /** 确认 */
    confirm() {
      this.$emit('delegate', this.currentRoomAmount, this.currentAdultAmount, this.currentChildAmount, this.currentAges)
      this.close()
    },

    /** 关闭 */
    close() {
      this.$refs.refDialog && this.$refs.refDialog.close()
    }
  },
  components: {
    Teleport,
    CCheckRoomAges,
    HsScroll,
    HsDialog,
    CDialogHeader,
    HsButton
  }
}
</script>

<template>
  <hs-dialog ref="refDialog" v-model="currentShow" :position="position" :positionHeight="positionHeight">
    <div class="starAndPriceDialog" :class="{ 'hs-filter-top': position === 'top', 'van-safe-area-bottom': position !== 'top' }" @click.stop>
      <c-dialog-header :title="$t('PleaseSelectTheRoomAndRoomer')" @close="close"/>
      <hs-scroll class="table-view" ref="tableView">
        <div class="cell">
          <span>{{ $t('NumberOfRoom') }}</span>
          <div class="stepper">
            <van-stepper
                ref="vanStepper1"
                :value="currentRoomAmount" integer :min="minRoomAmount" :max="RoomAmountLimit"
                input-width="48px" button-size="32px" async-change
                @change="roomAmountChange"
            />
          </div>
        </div>
        <div class="cell">
          <span>{{ $t('NumberOfAdult') }}</span>
          <div class="stepper">
            <van-stepper
                ref="vanStepper2"
                :value="currentAdultAmount" integer :min="currentRoomAmount * minAdultAmount"
                :max="PeopleAmountLimit - currentChildAmount"
                input-width="48px" button-size="32px" async-change
                @change="changeFun"
            />
          </div>
        </div>
        <div class="cell">
          <span>{{ $t('NumberOfChild') }}</span>
          <div class="stepper">
            <van-stepper
                ref="vanStepper3"
                :value="currentChildAmount" integer :min="currentRoomAmount * minChildAmount"
                :max="PeopleAmountLimit - currentAdultAmount"
                input-width="48px" button-size="32px" async-change
                @change="changeChildFun"
            />
          </div>
        </div>
        <div class="children" v-if="currentChildAmount > 0">
          <div class="space"></div>
          <div class="children-content">
            <div class="header">{{ $t('ChildOfAge') }}</div>
            <div class="subtitle">{{ $t('AccuratelyFillInTheAgeOfEachChildForSpecialOffers') }}</div>
            <div class="children-cell" v-for="(item, index) in currentAges" :key="index" @click="openCCheckRoomAge(item, index)">
              <span>{{ $t('TheAgeOfTheChild_x', 'function', [index + 1]) }}</span>
              <div class="children-age" v-if="getAgesText(item)">{{ getAgesText(item) }}</div>
              <div class="children-age gray" v-else>{{ $t('RequiredChoose') }}</div>
            </div>
          </div>
        </div>
      </hs-scroll>
      <footer>
        <hs-button width="100%" height="38px" fontSize="14px" @click="confirm">{{ $t('Confirm') }}</hs-button>
      </footer>
    </div>
    <c-check-room-ages
        :show.sync="showCCheckRoomAges"
        :age="cCheckRoomAge"
        :index="cCheckRoomAgeIndex"
        @delegate="cCheckRoomAgesCallback"
    />
  </hs-dialog>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.starAndPriceDialog {
  @extend .flex-column;
  @extend .flex-end;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: $color_black_0;
  max-height: 90%;
  overflow-y: auto;
  border-radius: 10px 10px 0 0;

  &.hs-filter-top {
    bottom: auto;
    top: 0;
    border-radius: 0;
  }

  .table-view {
    width: 100%;
    max-height: calc(100% - 118px);
    overflow-y: auto;

    .cell {
      @extend .flex-between;
      @extend .hs-font-body;
      color: $color_black_600;
      padding: 15px 12px;

      > .stepper {
        border: 0.5px solid $color_black_40;
        border-radius: 4px;

        >>> .van-stepper__minus, >>> .van-stepper__plus {
          background-color: $color_black_0;

          &::before {
            width: 10px;
            height: 2px;
            border-radius: 2px;
          }

          &::after {
            width: 2px;
            height: 10px;
            border-radius: 2px;
          }
        }

        >>> .van-stepper__input {
          background-color: $color_black_0;
          border-left: 0.5px solid $color_black_40;
          border-right: 0.5px solid $color_black_40;
          color: $color_black_900;
          font-size: 15px;
          font-weight: 400;
          line-height: 21px;
          text-align: center;
        }
      }
    }

    .children {
      .space {
        width: 100%;
        height: 7px;
        background-color: $color_black_10;
      }

      .children-content {
        width: 100%;
        padding: 12px 12px 0 12px;

        .header {
          @extend .hs-font-subtitle-big;
          color: $color_black_900;
          margin-bottom: 4px;
        }

        .subtitle {
          @extend .hs-font-caption-1;
          color: $color_black_100;
          margin-bottom: 16px;
        }

        .children-cell {
          @extend .flex-between;
          @extend .hs-font-body;
          width: 100%;
          padding: 14px 12px;
          border-radius: 4px;
          background-color: $color_black_20;
          color: $color_black_600;
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0;
          }

          .children-age {
            @extend .flex-start;
            color: $color_black_900;

            &.gray {
              color: $color_black_50;
            }

            &::after {
              display: flex;
              content: " ";
              width: 16px;
              height: 16px;
              background: url(@/assets/image/base/cell/icons_16pt_more.png) no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }

  footer {
    @extend .flex-between;
    width: 100%;
    box-shadow: 0 5px 10px $color_gray_layer;
    padding: 16px 12px;
    margin-bottom: 0;

    .hs-button {
      border-radius: 8px;
    }
  }
}
</style>
